import React, { useState } from 'react';

export default function RealSummaryCards({
  totalPnl,
  totalLiveProfit,
  totalPlannedRisk,
  currentValue,
  investedValue,
  worstCaseWallet,
  availableBalance,
  totalLiveRisk,
  plannedRiskBreakdown = [],
  worstCaseWalletBreakdown,
  formatCurrency,
}) {
  const [showMore, setShowMore] = useState(false);
  const coreCards = [
    {
      key: 'pnl',
      label: 'Total P&L',
      icon: 'P/L',
      value: totalPnl,
      tone: totalPnl >= 0 ? 'positive' : 'negative',
      note: 'Holdings + open positions',
      featured: true,
    },
    {
      key: 'profit',
      label: 'Live profit',
      icon: 'LP',
      value: totalLiveProfit,
      tone: totalLiveProfit >= 0 ? 'positive' : 'negative',
      note: 'Mark-to-market',
    },
    {
      key: 'cash',
      label: 'Available balance',
      icon: 'AB',
      value: availableBalance,
      note: 'Free cash',
    },
    {
      key: 'risk',
      label: 'Live risk',
      icon: 'TR',
      value: totalLiveRisk,
      note: 'Open positions + holdings',
      quiet: true,
    },
  ];

  const secondaryCards = [
    {
      key: 'planned-risk',
      label: 'Live risk used',
      icon: 'PR',
      value: totalPlannedRisk,
      note: '',
      breakdown: plannedRiskBreakdown,
    },
    {
      key: 'current-value',
      label: 'Current value',
      icon: 'CV',
      value: currentValue,
      note: 'Market value',
    },
    {
      key: 'invested-value',
      label: 'Invested value',
      icon: 'IV',
      value: investedValue,
      note: 'Average buy price',
    },
    {
      key: 'worst-case-wallet',
      label: 'Worst-case wallet',
      icon: 'WC',
      value: worstCaseWallet,
      note: 'Net cash + invested - risk',
    },
  ];

  return (
    <section className="metric-stack" aria-label="Portfolio summary">
      <div className="metric-grid metric-grid-core">
        {coreCards.map((card) => (
          <article key={card.key} className={`metric-card${card.featured ? ' metric-card-featured' : ''}${card.quiet ? ' metric-card-quiet' : ''}`}>
            <div className="metric-label">{card.label} <span className="metric-icon">{card.icon}</span></div>
            <strong className={card.tone || ''}>{formatCurrency(card.value)}</strong>
            <small>{card.note}</small>
          </article>
        ))}
      </div>
      <div className="metric-more">
        <button
          type="button"
          className="metric-more-toggle"
          onClick={() => setShowMore((value) => !value)}
          aria-expanded={showMore}
          aria-controls="metric-secondary-strip"
        >
          {showMore ? 'Show less' : 'Show more'}
        </button>
        {showMore ? (
          <div id="metric-secondary-strip" className="metric-strip" aria-label="Additional portfolio metrics">
            {secondaryCards.map((card) => (
              <article key={card.key} className="metric-chip">
                <div className="metric-label">{card.label} <span className="metric-icon">{card.icon}</span></div>
                <strong>{formatCurrency(card.value)}</strong>
                <small>{card.note}</small>
              </article>
            ))}
          </div>
        ) : null}
      </div>
    </section>
  );
}
